import React, {Component} from 'react'
import {Button} from '@sabre/spark-react'
import ReactToPrint from 'react-to-print'
import WeatherResponse from 'shared/components/WeatherResponse/index'
import withProgress from 'shared/hoc/progress/index'

export default class Weather extends Component {
    noWeatherText = "No weather found for requested flight."

    constructor(props) {
        super(props)
        this.weatherResponse = React.createRef()
        this.state = {
            flightId: this.props.match.params.flightId
        }
    }

    componentWillUnmount() {
        this.props.actions.resetFlightWeather()
    }

    componentWillMount() {
        this.props.actions.getFlightWeather(this.state.flightId)
    }

    render() {
        const ContentWithProgress = withProgress('div')
        return (
            <React.Fragment>
                <div className="row spark-mar-t-2 spark-mar-2--gte-md">
                    <div className="col-md-12">
                        <ContentWithProgress className="min-height-400" loading={this.props.isLoading}>
                            <div className="row spark-mar-t-2 spark-mar-2--gte-md">
                                <div className="col-md-12">
                                    <div className="spark-text-right">
                                        <ReactToPrint
                                            trigger={() => (<Button
                                                onClick={() => {}}
                                                icon="spark-icon-print"
                                                iconOnly
                                                title="Print"
                                                disabled={(!this.props.data || this.props.data.length === 0)}
                                            />)}
                                            content={() => this.weatherResponse}
                                            bodyClass="spark-mar-2"/>
                                    </div>
                                    <WeatherResponse ref={el => {this.weatherResponse = el}}
                                                     noWeatherText={this.noWeatherText} airports={this.props.data}/>
                                </div>
                            </div>
                        </ContentWithProgress>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/briefing/weather/components/index.js